import React, { Suspense, useEffect, useState } from 'react';
import { initializeEcho } from '@services/echo';
import { useSelector } from 'react-redux';
import { selectSession } from '@state/selectors';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { renderRoutes } from 'react-router-config';
import { LinearProgress } from '@mui/material';
import { NavBar, TopBar } from './components';
import { BreadCrumbs } from '@components';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  topBar: {
    zIndex: 2,
    position: 'relative',
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  navBar: {
    zIndex: 3,
    flex: '0 0 auto',
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto',
  },
}));

const Dashboard = ({ route }) => {
  const classes = useStyles();
  const session = useSelector(selectSession);
  const [isOpenedNav, setIsOpenedNav] = useState(true);
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  useEffect(() => {
    if (session.loggedIn) {
      const Echo = initializeEcho();
      const usersActivitiesChannel = `users.${session.user.id}.activities`;
      console.info(`Echo joining channel - ${usersActivitiesChannel}`);
      Echo.join(usersActivitiesChannel);

      const leaveUsersChannel = () => {
        Echo.leave(usersActivitiesChannel);
      };

      window.addEventListener('beforeunload', leaveUsersChannel);

      return () => {
        window.removeEventListener('beforeunload', leaveUsersChannel);
        leaveUsersChannel();
      };
    }
  }, [session.loggedIn, session.user.id]);

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  return (
    <Suspense fallback={<div />}>
      <div className={classes.root}>
        <TopBar
          className={classes.topBar}
          onOpenNavBarMobile={handleNavBarMobileOpen}
        />
        <div className={classes.container}>
          <NavBar
            className={classes.navBar}
            openMobile={openNavBarMobile}
            handleCollapsedNav={setIsOpenedNav}
            onMobileClose={handleNavBarMobileClose}
            style={{
              width: isOpenedNav ? 256 : 120,
              minWidth: isOpenedNav ? 256 : 120,
            }}
          />
          <main className={classes.content}>
            <Suspense fallback={<LinearProgress />}>
              <BreadCrumbs />
              {renderRoutes(route.routes)}
            </Suspense>
          </main>
        </div>
      </div>
    </Suspense>
  );
};

Dashboard.propTypes = {
  route: PropTypes.object,
};

export default Dashboard;
